declare const CookieScript;

import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';
import TvProduct from './components/TvProduct/TvProduct';

const BUFFER = 5000;

const GET_SCREEN = gql`
  query GetScreen($shop: String!, $screen: String!) {
    screen(shop: $shop, screen: $screen) {
      current {
        contentType
        content
        duration
        startAt
      }
    }
  }
`;

const Tv = () => {
  const { shop, screen } = useParams<{ shop: string; screen: string }>();
  const { data, refetch } = useQuery(GET_SCREEN, {
    variables: { shop, screen },
    pollInterval: 30000,
  });

  const startAt = data?.screen?.current?.startAt;
  const duration = (data?.screen?.current?.duration || 0) * 1000;

  useEffect(() => {
    CookieScript?.instance?.acceptAllAction();

    // Hide cookie badge
    setTimeout(() => {
      const cookieBadge = document.getElementById('cookiescript_badge');
      if (cookieBadge) {
        cookieBadge.style.display = 'none';
      }
    }, 1000);
    setTimeout(() => {
      const cookieBadge = document.getElementById('cookiescript_badge');
      if (cookieBadge) {
        cookieBadge.style.display = 'none';
      }
    }, 2000);
    setTimeout(() => {
      const cookieBadge = document.getElementById('cookiescript_badge');
      if (cookieBadge) {
        cookieBadge.style.display = 'none';
      }
    }, 3000);
  }, []);

  useEffect(() => {
    if (!startAt || !duration) {
      return;
    }

    let timer;
    const startAtTimestamp = new Date(startAt).getTime();
    const nextTimeout = startAtTimestamp + duration + BUFFER - Date.now();

    if (nextTimeout) {
      timer = setTimeout(() => {
        refetch();
      }, nextTimeout);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [startAt, duration]);

  if (!data) {
    return (
      <div className="grid h-screen place-items-center">
        <div
          className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        ></div>
      </div>
    );
  }

  if (data.screen.current?.contentType === 'PRODUCT') {
    return <TvProduct slug={data.screen.current.content} />;
  }

  if (data.screen.current?.contentType === 'IMAGE') {
    return (
      <div
        className="relative w-screen h-screen"
        style={{ width: '100%', height: '100%' }}
      >
        <style>{` html, body { margin: 0; padding: 0; } `}</style>
        <img
          src={data.screen.current.content}
          className="w-full h-auto object-cover fixed top-0 left-0"
          alt="TV"
          style={{ width: '100%', height: '100%' }}
        />
        {/* red button for cache check */}
        <button className="absolute top-8 left-8 bg-red-500 h-2 px-1 rounded-full text-xs flex items-center justify-center"></button>
      </div>
    );
  }
  if (data.screen.current?.contentType === 'VIDEO') {
    return (
      <video
        autoPlay
        muted
        src={data.screen.current.content}
        className="absolute z-10 w-full h-full bg-black"
      />
    );
  }
  return null;
};

export default Tv;
